export const interestLenderPredicate = <
  Lender extends { loanType: "interest" } | { loanType: "profitShare" },
>(
  lender: Lender,
): lender is Extract<Lender, { loanType: "interest" }> =>
  lender.loanType === "interest";
